require("gsap/CSSPlugin");

window.$ = window.jQuery = require("jquery");
require("datatables.net");
require("datatables.net-responsive");
// require("datatables.net-fixedheader");

//images
require("../../../images/icons/icon-fb.svg");
require("../../../images/icons/icon-instagram.svg");

var Navigo = require("navigo");
var Handlebars = require("handlebars/runtime");
var results_table_template = require("../templates/results-table.handlebars");
var racer_details_template = require("../templates/racer-details.handlebars");



var initShareButtons = require("../blocks/share");

var page_scroll_position;

var buildDiplomaHtml = function (data, pageUrl) {
	var rd = data.racer_data || {};
	var rr = data.racer_result || {};
	var rc = data.race_data || {};
	var st = data.stats || {};
	var routeName = data.route_name || "";

	var raceDate = "";
	if (rc.race_date) {
		var d = new Date(rc.race_date);
		var months = ["gennaio","febbraio","marzo","aprile","maggio","giugno",
		              "luglio","agosto","settembre","ottobre","novembre","dicembre"];
		raceDate = d.getDate() + " " + months[d.getMonth()] + " " + d.getFullYear();
	}

	var raceLocation = "";
	if (rc.race_gmaps_city) {
		raceLocation = rc.race_gmaps_city;
		if (rc.race_gmaps_state) { raceLocation += " (" + rc.race_gmaps_state + ")"; }
	}

	var athleteName = ((rd.name || "") + " " + (rd.surname || "")).trim();
	var logoUrl = window.location.origin + "/images/logo-typography-black.svg";
	var organizerLogoUrl = (typeof ORGANIZER_LOGO_URL !== "undefined" && ORGANIZER_LOGO_URL) ? ORGANIZER_LOGO_URL : "";
	var qrUrl = "https://api.qrserver.com/v1/create-qr-code/?size=128x128&data=" + encodeURIComponent(pageUrl || window.location.href);

	// Medaglia SVG: nastro (arancio+giallo) + cerchio oro + stella
	var medalSvg =
		"<svg width=\"40\" height=\"50\" viewBox=\"0 0 40 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">" +
			"<rect x=\"10\" y=\"0\" width=\"8\" height=\"15\" rx=\"2\" fill=\"#EA7125\"/>" +
			"<rect x=\"22\" y=\"0\" width=\"8\" height=\"15\" rx=\"2\" fill=\"#FFB60F\"/>" +
			"<circle cx=\"20\" cy=\"34\" r=\"16\" fill=\"#FFB60F\"/>" +
			"<circle cx=\"20\" cy=\"34\" r=\"12\" fill=\"#FFC72C\"/>" +
			"<polygon points=\"20,25 22,31 29,31 23,35 25,41 20,38 15,41 17,35 11,31 18,31\" fill=\"#212121\" opacity=\"0.2\"/>" +
		"</svg>";

	var css = [
		"@page { size: A5 landscape; margin: 0; }",
		"* { box-sizing: border-box; margin: 0; padding: 0; }",
		"html, body { width: 794px; height: 560px; overflow: hidden; }",
		"body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-weight: 300; color: #212121; background: #fff; }",
		".diploma-page { width: 794px; height: 560px; overflow: hidden; display: flex; flex-direction: column; border-left: 6px solid #FFB60F; page-break-inside: avoid; page-break-after: avoid; }",
		".diploma-header { display: flex; align-items: center; gap: 12px; padding: 16px 20px 14px 20px; border-bottom: 3px solid #FFB60F; }",
		".diploma-title { font-size: 30px; font-weight: 300; letter-spacing: 0.25em; text-transform: uppercase; color: #212121; line-height: 1; }",
		".diploma-logo { height: 34px; }",
		".diploma-organizer-logo { height: 34px; margin-left: auto; margin-right: 16px; }",
		".diploma-body { display: flex; padding: 14px 20px 10px 20px; gap: 20px; flex: 1; min-height: 0; overflow: hidden; }",
		".diploma-left { flex: 1; padding-right: 18px; border-right: 1px solid #E5E5E5; display: flex; flex-direction: column; }",
		".diploma-right { flex: 0 0 155px; display: flex; flex-direction: column; gap: 6px; justify-content: center; }",
		".event-meta { margin-bottom: 10px; }",
		".event-date { font-size: 10px; color: #44687D; text-transform: uppercase; letter-spacing: 0.1em; font-weight: 600; }",
		".event-location { font-size: 10px; color: #888; margin-top: 1px; }",
		".event-title { margin-top: 8px; font-size: 13px; font-weight: 700; color: #212121; line-height: 1.2; }",
		".event-route { margin-top: 2px; font-size: 10px; color: #44687D; }",
		".athlete-divider { border: none; border-top: 1px solid #E5E5E5; margin: 8px 0; }",
		".athlete-name { font-size: 21px; font-weight: 700; color: #212121; line-height: 1.15; margin-bottom: 8px; }",
		".athlete-meta { list-style: none; }",
		".athlete-meta li { font-size: 10px; color: #555; margin-bottom: 3px; display: flex; gap: 6px; }",
		".athlete-meta li label { font-weight: 600; color: #212121; min-width: 66px; }",
		".athlete-qr { margin-top: auto; padding-top: 8px; display: flex; align-items: center; gap: 8px; }",
		".athlete-qr img { display: block; width: 60px; height: 60px; flex-shrink: 0; }",
		".athlete-qr-label { font-size: 8px; color: #bbb; line-height: 1.4; max-width: 90px; }",
		".stat-box { border-radius: 4px; padding: 0 12px; height: 44px; color: #fff; display: flex; flex-direction: column; justify-content: center; }",
		".stat-box .stat-label { font-size: 8px; text-transform: uppercase; letter-spacing: 0.12em; font-weight: 600; opacity: 0.85; margin-bottom: 2px; }",
		".stat-box .stat-value { font-size: 20px; font-weight: 700; line-height: 1; }",
		".stat-bib { background-color: #FFB60F; color: #212121; }",
		".stat-overall { background-color: #212121; }",
		".stat-category { background-color: #44687D; }",
		".stat-time { background-color: #EA7125; }",
		".diploma-footer { border-top: 2px solid #FFB60F; padding: 8px 20px; display: flex; align-items: center; justify-content: space-between; gap: 10px; }",
		".footer-tagline { font-size: 9px; color: #aaa; letter-spacing: 0.08em; }",
		".footer-link { font-size: 10px; color: #44687D; text-decoration: none; letter-spacing: 0.05em; }",
		".footer-logo { height: 22px; }",
		"@media print {",
		"  html, body { width: 794px; height: 560px; }",
		"  .diploma-page { -webkit-print-color-adjust: exact; print-color-adjust: exact; }",
		"  .stat-bib, .stat-overall, .stat-category, .stat-time { -webkit-print-color-adjust: exact; print-color-adjust: exact; }",
		"}"
	].join("\n");

	var teamRow    = rr.team     ? "<li><label>Team</label><span>" + rr.team + "</span></li>" : "";
	var catRow     = rr.category ? "<li><label>Categoria</label><span>" + rr.category + "</span></li>" : "";
	var genderRow  = rd.gender   ? "<li><label>Sesso</label><span>" + rd.gender + "</span></li>" : "";
	var bibVal     = rr.bib      ? "#" + rr.bib : "—";
	var overallVal = st.overall_position  ? "#" + st.overall_position  : "—";
	var catVal     = st.category_position ? "#" + st.category_position : "—";
	var timeVal    = st.total_time || "—";

	return "<!DOCTYPE html>\n" +
		"<html lang=\"it\"><head><meta charset=\"UTF-8\">" +
		"<meta name=\"viewport\" content=\"width=794, initial-scale=1.0\">" +
		"<title>Diploma - " + athleteName + "</title>" +
		"<style>" + css + "</style></head><body>" +
		"<div class=\"diploma-page\">" +
		"<div class=\"diploma-header\">" +
			medalSvg +
			"<div class=\"diploma-title\">Diploma</div>" +
			(organizerLogoUrl ? "<img class=\"diploma-organizer-logo\" src=\"" + organizerLogoUrl + "\" alt=\"organizzatore\" />" : "") +
			"<img class=\"diploma-logo\" src=\"" + logoUrl + "\" alt=\"IDchronos\"" + (organizerLogoUrl ? "" : " style=\"margin-left:auto\"") + " />" +
		"</div>" +
		"<div class=\"diploma-body\">" +
			"<div class=\"diploma-left\">" +
				"<div class=\"event-meta\">" +
					"<div class=\"event-date\">" + raceDate + "</div>" +
					"<div class=\"event-location\">" + raceLocation + "</div>" +
					"<div class=\"event-title\">" + (rc.race_title || "") + "</div>" +
					"<div class=\"event-route\">" + routeName + "</div>" +
				"</div>" +
				"<hr class=\"athlete-divider\" />" +
				"<div class=\"athlete-name\">" + athleteName + "</div>" +
				"<ul class=\"athlete-meta\">" + teamRow + catRow + genderRow + "</ul>" +
				"<div class=\"athlete-qr\">" +
					"<img src=\"" + qrUrl + "\" alt=\"QR risultati\" />" +
					"<span class=\"athlete-qr-label\">Scansiona per rivivere il tuo risultato</span>" +
				"</div>" +
			"</div>" +
			"<div class=\"diploma-right\">" +
				"<div class=\"stat-box stat-bib\"><div class=\"stat-label\">Pettorale</div><div class=\"stat-value\">" + bibVal + "</div></div>" +
				"<div class=\"stat-box stat-overall\"><div class=\"stat-label\">Posizione assoluta</div><div class=\"stat-value\">" + overallVal + "</div></div>" +
				"<div class=\"stat-box stat-category\"><div class=\"stat-label\">Posizione categoria</div><div class=\"stat-value\">" + catVal + "</div></div>" +
				"<div class=\"stat-box stat-time\"><div class=\"stat-label\">Tempo ufficiale</div><div class=\"stat-value\">" + timeVal + "</div></div>" +
			"</div>" +
		"</div>" +
		"<div class=\"diploma-footer\">" +
			"<a class=\"footer-link\" href=\"https://www.idchronos.it\" target=\"_blank\">www.idchronos.it</a>" +
			"<div style=\"display:flex;align-items:center;gap:10px;\">" +
				"<div class=\"footer-tagline\">cronometrato da</div>" +
				"<img class=\"footer-logo\" src=\"" + logoUrl + "\" alt=\"IDchronos\" />" +
			"</div>" +
		"</div>" +
		"</div>" +
		"<script>window.onload=function(){window.print();window.onafterprint=function(){window.close();};};<\/script>" +
		"</body></html>";
};

if (typeof CUR_RACE_ID !== "undefined") {
	var share_url =
		APP_ROOT +
		"/" +
		LOCALE +
		"/" +
		TRANSLATED_SECTION_NAME +
		"/" +
		CUR_RACE_ID +
		"/" +
		CUR_RACE_SLUG;

	var routeSelect; // Custom select instance for route dropdown
	var results_loading_status = "idle";

	/*
	 * Racer details
	 */
	var loadRacerDetails = function (race_id, racer_id) {
		$.post(
			APP_ROOT +
				"/api/" +
				LOCALE +
				"/v1/results/" +
				race_id +
				"/racer/" +
				racer_id,
			displayRacerDetails,
			"json"
		);
	};

	var displayRacerDetails = function (racer_details) {
		racer_details.app_root = APP_ROOT;

		$(document).ready(function () {
			page_scroll_position = $(document).scrollTop();
			$(document).scrollTop(0);

			var racer_details_html = racer_details_template(racer_details);

			$(".page-content").css({ display: "none" });

			$(".content-wrapper").append(racer_details_html);

			var currentUrl = window.location.href;
			$(".racer-details .share-fb-button").data("link", currentUrl);
			$(".racer-details .share-instagram-button").data("link", currentUrl);

			initShareButtons($(".share-race-results"));

			$(".racer-details #print-btn").on("click", function () {
				var w = window.open("", "_blank", "width=794,height=560");
				if (!w || w.closed || typeof w.closed === "undefined") {
					alert("Il tuo browser ha bloccato la finestra del diploma. Consenti i popup per questo sito.");
					return;
				}
				w.document.write(buildDiplomaHtml(racer_details, currentUrl));
				w.document.close();
			});

			$(".back-button").click(function (e) {
				e.preventDefault();
				router.navigate(router.root, true);
			});
		});
	};

	/*
	 * ---------------------------------------------------------------------
	 * Preparazione dei dati di classifica
	 *
	 * Tutti i campi derivati mostrati in tabella sono calcolati qui, non nel
	 * template: il runtime Handlebars è precompilato e registrare helper
	 * costringerebbe a toccare la build. In più il JSON di percorso è
	 * cachato in race_routes.race_route_results, quindi calcolare lato
	 * client evita di invalidare la cache di tutte le gare esistenti.
	 * ---------------------------------------------------------------------
	 */

	// Alias più frequenti nei file di import (il campo nazionalità è testo
	// libero) verso codice ISO-3166 alpha-2, da cui si ricava l'emoji
	// bandiera senza bisogno di asset immagine.
	var NATIONALITY_ALIASES = {
		IT: "IT", ITA: "IT", ITALIA: "IT", ITALY: "IT",
		FR: "FR", FRA: "FR", FRANCIA: "FR", FRANCE: "FR",
		DE: "DE", GER: "DE", DEU: "DE", GERMANIA: "DE", GERMANY: "DE",
		ES: "ES", ESP: "ES", SPAGNA: "ES", SPAIN: "ES",
		GB: "GB", GBR: "GB", UK: "GB", ENG: "GB",
		IE: "IE", IRL: "IE", IRLANDA: "IE",
		CH: "CH", SUI: "CH", SVI: "CH", SVIZZERA: "CH", SWITZERLAND: "CH",
		AT: "AT", AUT: "AT", AUSTRIA: "AT",
		SI: "SI", SLO: "SI", SVN: "SI", SLOVENIA: "SI",
		HR: "HR", CRO: "HR", CROAZIA: "HR",
		CZ: "CZ", CZE: "CZ", RCH: "CZ",
		SK: "SK", SVK: "SK",
		PL: "PL", POL: "PL", POLONIA: "PL",
		RO: "RO", ROU: "RO", ROM: "RO", ROMANIA: "RO",
		PT: "PT", POR: "PT", PRT: "PT", PORTOGALLO: "PT",
		BE: "BE", BEL: "BE", BELGIO: "BE",
		NL: "NL", NED: "NL", NLD: "NL", OLANDA: "NL",
		MA: "MA", MAR: "MA", MOR: "MA", MAROCCO: "MA",
		TN: "TN", TUN: "TN",
		KE: "KE", KEN: "KE", KENYA: "KE",
		ET: "ET", ETH: "ET",
		ER: "ER", ERI: "ER",
		SM: "SM", SMR: "SM",
		US: "US", USA: "US",
		AR: "AR", ARG: "AR",
		BR: "BR", BRA: "BR",
		AL: "AL", ALB: "AL", ALBANIA: "AL",
		UA: "UA", UKR: "UA",
		RU: "RU", RUS: "RU",
		HU: "HU", HUN: "HU",
		BG: "BG", BGR: "BG", BUL: "BG",
		GR: "GR", GRE: "GR", HEL: "GR", GRECIA: "GR"
	};

	var flagEmoji = function (nationality) {
		var key = String(nationality || "").trim().toUpperCase();
		var iso2 = NATIONALITY_ALIASES[key];

		if (!iso2) return "";

		return (
			String.fromCharCode(0xd83c, 0xdde6 + iso2.charCodeAt(0) - 65) +
			String.fromCharCode(0xd83c, 0xdde6 + iso2.charCodeAt(1) - 65)
		);
	};

	/*
	 * Gap compatto: il backend lo produce come "H:MM:SS" (differenza dal
	 * primo) oppure come "+N" quando l'atleta ha completato meno giri.
	 * Regole: prefisso "+", zeri di testa omessi, niente gap per il leader.
	 *   "0:00:00" / leader -> ""        "0:00:53" -> "+53"
	 *   "0:01:48"          -> "+1:48"   "1:02:03" -> "+1:02:03"
	 *   "+1"               -> "+1 giro"
	 */
	var formatGap = function (raw, is_leader, laps_label_one, laps_label_many) {
		if (is_leader || !raw || raw === "ND" || raw === "n/a") return "";

		raw = String(raw);

		if (raw.charAt(0) === "+") {
			var laps_diff = parseInt(raw.slice(1), 10);
			if (isNaN(laps_diff) || laps_diff <= 0) return "";
			return "+" + laps_diff + " " + (laps_diff === 1 ? laps_label_one : laps_label_many);
		}

		var parts = raw.split(":");
		if (parts.length !== 3) return "";

		var h = parseInt(parts[0], 10) || 0;
		var m = parseInt(parts[1], 10) || 0;
		var s = parseInt(parts[2], 10) || 0;
		var pad = function (n) { return n < 10 ? "0" + n : "" + n; };

		if (h > 0) return "+" + h + ":" + pad(m) + ":" + pad(s);
		if (m > 0) return "+" + m + ":" + pad(s);
		if (s > 0) return "+" + s;

		return "";
	};

	var timeToSeconds = function (time) {
		var parts = String(time || "").split(":");
		if (parts.length !== 3) return 0;
		return (
			(parseInt(parts[0], 10) || 0) * 3600 +
			(parseInt(parts[1], 10) || 0) * 60 +
			(parseInt(parts[2], 10) || 0)
		);
	};

	// Markup della cella posizione: usato sia dal template sia dal
	// drawCallback, che riscrive la colonna dopo ogni filtro.
	var positionCellHtml = function (n) {
		var podium_class = "";
		if (n === 1) podium_class = " pos-abs--podium pos-abs--gold";
		else if (n === 2 || n === 3) podium_class = " pos-abs--podium pos-abs--other";

		return '<span class="pos-abs' + podium_class + '">' + n + "°</span>";
	};

	// Contatore "N atleti in classifica" sotto ai filtri: segue il numero di
	// righe effettivamente visibili dopo ricerca e filtri.
	var updateResultsCount = function () {
		var $target = $("#results-count-value");
		if (!$target.length) return;

		var $table = $("#standard-table");
		if (!$table.length || !$.fn.DataTable.isDataTable($table)) return;

		$target.text($table.DataTable().page.info().recordsDisplay);
	};

	// Pallino con il numero di filtri attivi sul bottone di apertura: su
	// mobile il pannello è chiuso, serve un indizio che qualcosa è filtrato.
	var updateActiveFiltersBadge = function () {
		var $badge = $(".filters-toggle__badge");
		if (!$badge.length) return;

		var active = 0;
		if ($('.gender-segmented__btn[aria-pressed="true"]').data("value")) active++;
		if ($("#category-select").val()) active++;

		$badge.text(active ? active : "");
		$(".results-filters").toggleClass("has-active-filters", active > 0);
	};

	/*
	 * Posizione di categoria e di sesso: il JSON di percorso non le contiene
	 * (esistono solo nel dettaglio del singolo atleta). Si ricavano scorrendo
	 * l'array, che arriva già ordinato per posizione assoluta.
	 */
	var prepareRacers = function (race_data) {
		var racers = race_data.racers || [];
		var t = race_data.translations || {};
		var laps_one = t.lap_one || "lap";
		var laps_many = t.lap_many || "laps";
		var count_by_category = {};
		var count_by_gender = {};

		racers.forEach(function (racer, index) {
			var category = String(racer.category || "").trim();
			var gender = String(racer.gender || "").trim();

			if (category) {
				count_by_category[category] = (count_by_category[category] || 0) + 1;
				racer.category_position = count_by_category[category];
			} else {
				racer.category_position = null;
			}

			if (gender) {
				var gender_key = gender.toLowerCase();
				count_by_gender[gender_key] = (count_by_gender[gender_key] || 0) + 1;
				racer.gender_position = count_by_gender[gender_key];
			} else {
				racer.gender_position = null;
			}

			// Valore di ordinamento per le colonne derivate: i "–" finiscono
			// in fondo invece di ordinarsi come stringa vuota.
			racer.category_position_order = racer.category_position || 99999;
			racer.gender_position_order = racer.gender_position || 99999;

			racer.gender_display = gender ? gender.toUpperCase() : "";
			racer.nat_display = racer.nationality ? String(racer.nationality).trim().toUpperCase() : "";
			racer.flag = flagEmoji(racer.nationality);
			racer.has_meta = !!(racer.flag || racer.nat_display || racer.team);

			racer.gap_display = formatGap(racer.gap, index === 0, laps_one, laps_many);
			racer.time_order = timeToSeconds(racer.time);

			racer.podium_class =
				racer.route_position === 1 ? "pos-abs--podium pos-abs--gold" :
				(racer.route_position === 2 || racer.route_position === 3) ? "pos-abs--podium pos-abs--other" : "";
		});

		return race_data;
	};

	var getRouteResults = function (race_id, route_id) {
		results_loading_status = "loading_route_data";
		$.post(
			APP_ROOT +
				"/api/" +
				LOCALE +
				"/v1/results/" +
				race_id +
				"/route/" +
				route_id,
			displayRoutesResults,
			"json"
		);
	};

	var displayRoutesResults = function (race_data) {
		/*
		 * Compile results template
		 */
		race_data.APP_ROOT = APP_ROOT;

		prepareRacers(race_data);

		var $nodes = $(results_table_template(race_data));

		$(".race-results-content").empty();
		$(".results-filters-slot").empty();

		// Il template produce due blocchi fratelli: il pannello filtri va
		// nella colonna laterale (sopra la tabella su mobile, dove la griglia
		// collassa), la tabella nella colonna principale.
		$nodes.filter(".results-filters").appendTo(".results-filters-slot");
		$nodes.not(".results-filters").appendTo(".race-results-content");

		// Riga cliccabile anche da tastiera: la <tr> ha tabindex/role="link",
		// Invio e Spazio replicano il click gestito qui sotto.
		$("#standard-table").on("keydown", "tbody tr", function (e) {
			if (e.key === "Enter" || e.key === " " || e.keyCode === 13 || e.keyCode === 32) {
				e.preventDefault();
				$(this).trigger("click");
			}
		});

		// Solo le righe del corpo tabella aprono il dettaglio atleta: legare
		// il click a "#standard-table tr" includeva anche la riga di header
		// (senza data-racer_id), per cui ordinare una colonna apriva il
		// dettaglio "racer/undefined" vuoto. Delega su tbody: regge i redraw
		// di DataTables (ordinamento, paginazione, filtri).
		$("#standard-table").on("click", "tbody tr", function (e) {
			var racerId = $(this).data("racer_id");
			if (racerId) {
				router.navigate("racer/" + racerId);
			}
		});

		// Etichette localizzate (arrivano da race_data.translations, con fallback)
		var t = race_data.translations || {};

		var dataTable = $("#standard-table").DataTable({
			bAutoWidth: false,
			order: [[0, "asc"]],
			responsive: {
				details: false,
			},
			paging: !$("#standard-table").hasClass("no-pagination"),
			fixedHeader: false,
			language: {
				paginate: {
					previous: t.previous || "Previous",
					next: t.next || "Next",
				},
			},
			infoCallback: function (settings, start, end, max, total, pre) {
				return start + "-" + end + " " + (t.of || "of") + " " + max;
			},
			dom: 't<"table-footer"ip<"dataTables_length">><"clear">',
			drawCallback: function (settings) {
				if (
					$("#standard-table").DataTable().page.info()
						.recordsDisplay == 0
				) {
					$(".table-footer").hide();
				} else {
					$(".table-footer").show();
				}

				if (settings.oPreviousSearch.sSearch.length == 0) {
					// if length == 0 user il filtering but not searching

					// update rows index after filtering
					// Si riscrive l'intero markup della cella, non il solo
					// numero: qui vivono il grado e l'evidenza del podio, che
					// altrimenti sparirebbero a ogni redraw.
					$("#standard-table")
						.DataTable()
						.column(0, { search: "applied", order: "original" })
						.nodes()
						.each(function (cell, i) {
							cell.innerHTML = positionCellHtml(i + 1);
						});
				}

				updateResultsCount();
			},

			initComplete: function () {
				// console.log($("#standard-table").hasClass("no-pagination"));
				// if ($("#standard-table").hasClass("no-pagination")) {
				// 	$(".table-footer").hide();
				// }
			},
		});

		/*
		 * Indici delle colonne filtrate. Sono legati alla posizione fisica
		 * delle colonne nel template: tenerli qui, con un nome, evita che un
		 * riordino futuro li scolleghi silenziosamente.
		 * 0 Pos | 1 Pettorale | 2 Atleta | 3 Pos.sesso | 4 Sesso |
		 * 5 Pos.categoria | 6 Categoria | (7 Giri) | Tempo
		 */
		var COLUMN_GENDER = 4;
		var COLUMN_CATEGORY = 6;

		var setTableFilter = function (column_num, value) {
			dataTable.column(column_num).search(value).draw();
		};

		/*
		 * Search
		 */
		$("#results-search__input").keyup(function () {
			dataTable.search($(this).val()).draw();
		});

		/*
		 * Sesso: segmented control (Tutti / M / F). Un solo valore attivo,
		 * un secondo click sul valore attivo azzera il filtro.
		 */
		$(".gender-segmented").on("click", ".gender-segmented__btn", function () {
			var $btn = $(this);
			var value = $btn.data("value") || "";
			var already_active = $btn.attr("aria-pressed") === "true";

			if (already_active && value !== "") {
				value = "";
			}

			$(".gender-segmented__btn").attr("aria-pressed", "false");
			$('.gender-segmented__btn[data-value="' + value + '"]').attr("aria-pressed", "true");

			setTableFilter(COLUMN_GENDER, value);
			updateActiveFiltersBadge();
		});

		/*
		 * Categoria
		 */
		$("#category-select").on("change", function () {
			setTableFilter(COLUMN_CATEGORY, $(this).val());
			updateActiveFiltersBadge();
		});

		/*
		 * Pannello filtri richiudibile: su mobile parte compatto, su desktop
		 * è sempre aperto (il bottone è nascosto via CSS).
		 */
		$(".filters-toggle").on("click", function () {
			var expanded = $(this).attr("aria-expanded") === "true";
			$(this).attr("aria-expanded", expanded ? "false" : "true");
			$(".results-filters").toggleClass("is-open", !expanded);
		});

		/*
		 * Reset
		 */
		$(".reset-filters").on("click", function () {
			$("#results-search__input").val("");
			$("#category-select").val("");
			$(".gender-segmented__btn").attr("aria-pressed", "false");
			$('.gender-segmented__btn[data-value=""]').attr("aria-pressed", "true");

			dataTable
				.search("")
				.column(COLUMN_GENDER).search("")
				.column(COLUMN_CATEGORY).search("")
				.draw();

			updateActiveFiltersBadge();
		});

		/*
		 *	Results per page menu
		 */
		var $page_length_select = $(
			'<select id="length-select" class="sld-select--no-border"></select>'
		);
		$page_length_select.append('<option value="10">10</option>');
		$page_length_select.append('<option value="25">25</option>');
		$page_length_select.append('<option value="50">50</option>');
		$page_length_select.appendTo(".dataTables_length");
		$(".dataTables_length").append(
			'<div class="select-label">' + (t.rows_per_page || "rows per page") + "</div>"
		);

		$page_length_select.on("change", function () {
			dataTable.page.len($(this).val()).draw();
		});

		/*
		 * append pagination commands outside table box
		 */
		$(".table-footer").appendTo(".results-main");

		updateResultsCount();

		results_loading_status = "idle";
	};

	$(document).ready(function () {
		initShareButtons($(".share-race-results"));

		/*
		 * Route selection handling
		 */
		var $routeSelectElement = $("#route-select");
		var enabledOptionsCount = $routeSelectElement.find("option:not([disabled])").length;

		// Attach change listener for loading results when route is selected
		$routeSelectElement.on("change", function () {
			var selectedRouteId = $(this).val();

			if (selectedRouteId && selectedRouteId !== "" && results_loading_status == "idle") {
				results_loading_status = "loading_route_data";
				// Hide the "select a route" splash message
				$('.select-route-splash').hide();
				getRouteResults(CUR_RACE_ID, selectedRouteId);
			}
		});

		if (enabledOptionsCount === 1) {
			// Single route available - auto-select it and load results
			var singleRouteId = $routeSelectElement.find("option:not([disabled])").val();
			if (singleRouteId) {
				// Select the single route in the dropdown
				$routeSelectElement.val(singleRouteId);
				// Auto-load results for this route
				getRouteResults(CUR_RACE_ID, singleRouteId);
			}
		} else if (enabledOptionsCount > 1) {
			// Multiple routes available - show dropdown with selection message
			var v_centred_splat_margin_top =
				($(window).height() -
					$(".main-nav").outerHeight() -
					$(".race-band").outerHeight()) /
					2 -
				$(".select-route-splash").height() / 2;

			if (v_centred_splat_margin_top > 0)
				$(".select-route-splash").css({
					"margin-top": v_centred_splat_margin_top,
				});

			$(".select-route-splash").animate({ opacity: 1 }, 300);
		}
	});

	/*
	 * Results router
	 */
	var router = new Navigo(
		(root =
			APP_ROOT +
			"/" +
			LOCALE +
			"/" +
			TRANSLATED_SECTION_NAME +
			"/" +
			CUR_RACE_ID +
			"/" +
			CUR_RACE_SLUG),
		(useHash = false)
	);

	router
		.on({
			"/racer/:id_racer": function (params) {
				loadRacerDetails(CUR_RACE_ID, params.id_racer);
			},

			"/": function () {
				$(".racer-details").remove();
				$(".page-content").css({ display: "block" });

				setTimeout(function () {
					$(document).scrollTop(page_scroll_position);
				}, 50);
			},
		})
		.resolve();
}
